import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import BackButton from "../components/BackButton";
import { getCountryCode } from "../Firebase";
import { GreeceTermsGreekBody } from "./GreeceTermsGreekBody";
import { GreeceTermsEnglishBody } from "./GreeceTermsEnglishBody";

function readMobiCountry() {
  try {
    const raw = sessionStorage.getItem("AI_MobiLoginResponse");
    if (!raw) return "";
    const d = JSON.parse(raw);
    return String(d?.Result?.Country || "").toUpperCase();
  } catch {
    return "";
  }
}

const TermsOfUse = () => {
  const { i18n, t } = useTranslation();
  const [geoCountry, setGeoCountry] = useState("");
  const mobiCountry = useMemo(() => readMobiCountry(), []);

  useEffect(() => {
    getCountryCode()
      .then((c) => setGeoCountry((c || "").trim().toUpperCase()))
      .catch(() => setGeoCountry("OTHER"));
  }, []);

  const lang = (
    i18n.language ||
    localStorage.getItem("i18nextLng") ||
    ""
  )
    .toString()
    .toLowerCase();
  const isGreekLang = lang.startsWith("el");
  const isPolish = lang.startsWith("pl");

  const isGreece = geoCountry === "GR" || mobiCountry === "GR";

  const englishContent = (
    <>
      <p className="fs-4">
        <strong>Effective Date: 17 Jan 2024</strong>
      </p>

      <p className="fs-4">
        Welcome to Avatalk AI! These Terms of Use ("Terms") govern your use of
        the Avatalk AI mobile application ("App"). By using the App, you agree
        to abide by these Terms. If you do not agree with any part of these
        Terms, please refrain from using the App.
      </p>

      <h1>1. Grant of License</h1>
      <p className="fs-4">
        Subject to your compliance with these Terms, we grant you a limited,
        non-exclusive, non-transferable, and revocable license to use the App
        solely for personal, non-commercial purposes. You may not sublicense,
        assign, or transfer this license.
      </p>

      <h1>2. User Conduct</h1>
      <p className="fs-4">You agree not to:</p>
      <ul>
        <li>Violate any applicable laws or regulations.</li>
        <li>
          Use the App in a manner that could interfere with, disrupt, negatively
          affect, or inhibit other users from fully enjoying the App.
        </li>
        <li>
          Use the App for any purpose other than its intended purpose of
          creating avatars using prompts or images.
        </li>
      </ul>

      <h1>3. Privacy</h1>
      <p className="fs-4">
        Your use of the App is also governed by our
        <a href="/Portal/privacy"> Privacy Policy </a>, which can be found here.
      </p>

      <h1>4. Intellectual Property</h1>
      <p className="fs-4">
        The App and its content, including but not limited to text, graphics,
        logos, images, and software, are the property of Avatalk AI or its
        licensors and are protected by intellectual property laws. You may not
        modify, reproduce, distribute, or create derivative works based on the
        App or its content.
      </p>

      <h1>5. Disclaimer of Warranties</h1>
      <p className="fs-4">
        The App is provided "as is" and "as available" without any warranties,
        express or implied. We do not warrant that the App will meet your
        requirements, be error-free, or operate without interruption.
      </p>

      <h1>6. Limitation of Liability</h1>
      <p className="fs-4">
        To the fullest extent permitted by applicable law, Avatalk AI and its
        affiliates, officers, employees, agents, and licensors shall not be
        liable for any indirect, incidental, special, consequential, or punitive
        damages, or any loss of profits or revenues.
      </p>

      <h1>7. Termination</h1>
      <p className="fs-4">
        We reserve the right to terminate or suspend your access to the App at
        our discretion, without notice, for any reason, including, but not
        limited to, a breach of these Terms.
      </p>

      <h1>8. Changes to Terms</h1>
      <p className="fs-4">
        We reserve the right to update or modify these Terms at any time.
        Changes will be effective immediately upon posting. Your continued use
        of the App after changes are posted constitutes your acceptance of the
        updated Terms.
      </p>
    </>
  );

  const renderBody = () => {
    if (isPolish && !isGreece) return null;
    if (isGreece) {
      return isGreekLang ? <GreeceTermsGreekBody /> : <GreeceTermsEnglishBody />;
    }
    return englishContent;
  };

  return (
    <div className="terms-of-use container mt-2">
      <BackButton title={t("portal.profile.termsConditions")} />
      {renderBody()}
    </div>
  );
};

export default TermsOfUse;
